import React from "react";
import outline from "../../assets/icons/home_service_1.svg";
import icon_1 from "../../assets/icons/cervical (1).png";
import icon_2 from "../../assets/icons/kidney (1).png";
import icon_3 from "../../assets/icons/oral-cancer (1).png";
import icon_4 from "../../assets/icons/stomach-cancer (1).png";
import icon_5 from "../../assets/icons/breast-cancer (1).png";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const HomeServices = () => {
  const services = [
    {
      title: "Head & Neck Oncology",
      describe: "We providing quality healthcare services to our community",
      icon: icon_3,
    },
    {
      title: "Breast Cancer Surgery",
      describe: "We providing quality healthcare services to our community",
      icon: icon_5,
    },
    {
      title: "GI & HPB Oncology",
      describe: "We providing quality healthcare services to our community",
      icon: icon_4,
    },
    {
      title: "Urological Oncology",
      describe: "We providing quality healthcare services to our community",
      icon: icon_2,
    },
    {
      title: "Gynecologic Oncology",
      describe: "We providing quality healthcare services to our community",
      icon: icon_1,
    },
  ];
  return (
    <div className=" xl:py-28 lg:py-20 md:py-14 py-10 relative ">
      <div className="bottom-0  left-0  absolute">
        <img src={outline} alt="outline" className="pointer-events-none" />
      </div>
      <div data-aos="fade-up" className="xl:w-[1280px] xl:px-10 2xl:px-0 px-0 w-11/12 mx-auto flex justify-center items-center flex-col z-10">
        <span className="text-xl font-medium text-[#1d9e75] uppercase border-b border-[#B87333] px-2 py-1.5 ">
          My Services
        </span>
        <h2 className="lg:text-4xl md:text-3xl text-xl text-center font-bold mt-2 text-matcha leading-tight">
          We Are Always Open For <br /> Your Health Services
        </h2>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 w-full  gap-10 mt-16">
          {services.map((item, index) => (
            <div
              key={item.title}
              className="shadow-[0px_12px_37.1px_0px_#d2ab802e] group bg-almond cursor-pointer rounded-md z-10  xl:p-10 p-8 flex flex-col"
            >
              <h3 className="mb-[15px] md:text-2xl text-xl font-bold text-matcha">
                {item.title}
              </h3>
              <p className="text-base xl:leading-[26px] leading-tight text-matcha">
                {item.describe}
              </p>
              <div className="mt-7 relative flex justify-between items-center after:absolute after:h-[1px] after:w-4/5 after:top-1/2 after:right-0 after:-z-0 after:bg-[#B87333]">
                <div>
                  <img
                    src={item.icon}
                    alt="icons"
                    loading="lazy"
                    className="w-14 z-10 relative transform transition-all duration-500 ease-[cubic-bezier(0.34,1.56,0.64,1)] group-hover:translate-x-2"
                  />
                </div>
                <div className="w-11 text-white font-bold text-xl group-hover:bg-matcha group-hover:text-vanilla group-hover:transition-all group-hover:duration-200 h-11 bg-[#1d9e75] flex justify-center items-center rounded-md z-10 relative">
                  0{index + 1}
                </div>
              </div>
            </div>
          ))}
          <div className="shadow-[0px_12px_37.1px_0px_#d2ab802e] bg-matcha rounded-md z-10  justify-between   xl:p-12 p-8 flex flex-col">
            <h3 className="mb-[15px] md:text-2xl text-xl font-bold text-white">
              Everything you need to know about oncology care
            </h3>
            <Link
              to="/contact-me"
              className="bg-[#1d9e75] py-3 w-40 text-white text-base font-semibold border border-[#1d9e75]  flex flex-row items-center justify-center gap-4 rounded-xl hover:bg-transparent  duration-200 transition"
            >
              Contact Me <ArrowRight strokeWidth={1} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeServices;
